<div class="flex-fill d-flex flex-column">
    <div class="flex-fill content-block dx-card responsive-paddings">
        <div class="d-flex flex-fill">
            <dx-data-grid
                #overviewGrid
                keyExpr="id"
                [dataSource]="recurringJobs"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
            >
                <dxi-data-grid-column dataField="startDate" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="endDate" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="displayFrequency" caption="Repeat Every" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="customer" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="address" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="uncompletedJobs" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="completedJobs" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="created" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="createdBy" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column></dxi-data-grid-column>

                <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="user-overview-grid"></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        type="button"
                        class="btn btn-primary me-1 mb-2"
                        (click)="delete(overviewGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Delete
                    </button>
                </div>
            </dx-data-grid>
        </div>
        <div class="autocomplete-container" id="autocomplete-container"></div>
    </div>
</div>
